import { isPlatform } from '@ionic/vue';

export async function requestMicrophoneStream(): Promise<MediaStream | null> {
  if (isPlatform('hybrid') || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    return null;
  }

  return navigator.mediaDevices.getUserMedia({ audio: true });
}

export async function requestMicrophonePermission(): Promise<boolean> {
  try {
    const stream = await requestMicrophoneStream();

    if (!stream) {
      return false;
    }

    stream.getTracks().forEach(track => track.stop());
    return true;
  } catch {
    return false;
  }
}
